/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { Action, createAction, props } from '@ngrx/store';
import { EventInterface, PlaylistInterface } from '../playlist/playlist.interface';
import { LocationModel } from '../models/location';

export enum PlayerActionTypes {
  Init = '[Player] Init',
  InitRecurrentLogs = '[Player] Init Recurrent Logs',
  InitListeners = '[Player] Init Listeners',

  RefreshLocation = '[Player] Refresh Only Location',
  RefreshLocationSuccess = '[Player] Refresh Only Location Success',

  RefreshBrowser = '[Player] Refresh Browser',

  MaxTrackErrorsReached = '[Player] Max Track Errors Reached',
  MaxTrackErrorsReachedSuccess = '[Player] Max Track Errors Reached Success',

  LocationIsLocked = '[Player] Location Is Locked',
  LocationIsNotLocked = '[Player] Location Is Not Locked',
  LocationLockedStatusReset = '[Player] Location Locked Status Reset',

  LoadLocation = '[Player] Load Location',
  LoadLocationSuccess = '[Player] Load Location Success',
  LoadLocationFailure = '[Player] Load Location Failure',

  ReloadLocation = '[Player] Reload Location',
  ReloadLocationSuccess = '[Player] Reload Location Success',
  ReloadLocationFailure = '[Player] Reload Location Failure',

  LoadPlaylist = '[Player] Load Playlist',
  LoadPlaylistFromServer = '[Player] Load Playlist From Server',
  LoadPlaylistFromLocalStorage = '[Player] Load Playlist From LocalStorage',
  LoadPlaylistFromLocalStorageSuccess = '[Player] Load Playlist From LocalStorage Success',
  LoadPlaylistSuccess = '[Player] Load Playlist Success',
  LoadPlaylistFailure = '[Player] Load Playlist Failure',

  SaveTrackListIntoLocalStorage = '[Player] Save Tracks List Into Local Storage',

  SetInitialTracks = '[Player] Set Initial Tracks',

  LoadMoreTracks = '[Player] Load More Tracks',
  LoadMoreTracksSuccess = '[Player] Load More Tracks Success',
  LoadMoreTracksFailure = '[Player] Load More Tracks Failure',

  PlayerIsReady = '[Player] Is Ready',
  // Prayer Time actions

  SetPrayerTimeOn = '[Prayer Time] Set On',
  SetPrayerTimeOff = '[Prayer Time] Is Off',

  SetAdOn = '[Ad] Set On',
  SetAdOff = '[Ad] Set Off',

  // Main Audio actions
  LoadNextTrack = '[Player] Load Next Track',
  LoadNextTrackSuccess = '[Player] Load Next Track Success',
  LoadNextTrackFailure = '[Player] Load Next Track Failure',

  LoadNextTrackAndPlay = '[Player] Load Next Track And Play',

  Play = '[Player] Play',
  PlayNext = '[Player] Play Next',
  ToggleMute = '[Player] Toggle Mute',
  Mute = '[Player] Mute',
  Unmute = '[Player] Unmute',
  ChangeVolume = '[Player] Change Volume',
  ChangeVolumeSuccess = '[Player] Change Volume Success',
  // Connection status
  IsOnline = '[Player] Is Online',
  IsOffline = '[Player] Is Offline',
  // Control Actions
  CleanObservers = '[Player] Clean Observers',
  ResetAll = '[Player] Reset All',
  ResetAllSuccess = '[Player] Reset All Success',
  // Location information
  RefreshLocationInformation = '[Player] Refresh Location Information',
  RefreshLocationInformationSuccess = '[Player] Refresh Location Information Success',
  RefreshLocationInformationFailure = '[Player] Refresh Location Information Failure',
  // Tracks management
  BypassTrackAndLoadNext = '[Player] Bypass Track And Load Next',
  // Autoplay permission deny
  AutoplayPermissionDenied = '[Player] Autoplay Permission Denied',
  AutoplayPermissionAllowed = '[Player] Autoplay Permission Allowed',
  statusListener1 = '[PLAYER] statusListener1',
  statusListener2 = '[PLAYER] statusListener2',
  statusListener3 = '[PLAYER] statusListener3',
  SendWrongRuntime = '[Player] Send wrong runtime',
  SendWrongRuntimeSuccess = '[Player] Send wrong runtime Success',
  SendWrongRuntimeFailure = '[Player] Send wrong runtime Failure',
}

export const Init = createAction(PlayerActionTypes.Init, props<{ locationGuid?: string }>());
export const InitRecurrentLogs = createAction(PlayerActionTypes.InitRecurrentLogs);
export const InitListeners = createAction(PlayerActionTypes.InitListeners);
export const RefreshLocation = createAction(PlayerActionTypes.RefreshLocation);
export const RefreshLocationSuccess = createAction(PlayerActionTypes.RefreshLocationSuccess);
export const RefreshBrowser = createAction(PlayerActionTypes.RefreshBrowser, props<{ immediate?: boolean }>());
export const MaxTrackErrorsReached = createAction(PlayerActionTypes.MaxTrackErrorsReached);
export const MaxTrackErrorsReachedSuccess = createAction(PlayerActionTypes.MaxTrackErrorsReachedSuccess);
export const LocationIsLocked = createAction(PlayerActionTypes.LocationIsLocked);

export const LocationIsNotLocked = createAction(PlayerActionTypes.LocationIsNotLocked, props<{ locationGuid?: string }>());
export const LocationLockedStatusReset = createAction(PlayerActionTypes.LocationLockedStatusReset);

export const LoadLocation = createAction(PlayerActionTypes.LoadLocation, props<{ locationGuid?: string }>());
export const LoadLocationSuccess = createAction(PlayerActionTypes.LoadLocationSuccess, props<{ location: LocationModel }>());

export const LoadLocationFailure = createAction(PlayerActionTypes.LoadLocationFailure);

export const ReloadLocation = createAction(PlayerActionTypes.ReloadLocation, props<{ locationGuid: string }>());
export const ReloadLocationSuccess = createAction(PlayerActionTypes.ReloadLocationSuccess, props<{ location: LocationModel }>());

export const ReloadLocationFailure = createAction(PlayerActionTypes.ReloadLocationFailure);
export const LoadPlaylist = createAction(PlayerActionTypes.LoadPlaylist, props<{ locationGuid: string }>());
export const LoadPlaylistFromServer = createAction(PlayerActionTypes.LoadPlaylistFromServer, props<{ locationGuid: string }>());

export const LoadPlaylistFromLocalStorage = createAction(PlayerActionTypes.LoadPlaylistFromLocalStorage);

export const LoadPlaylistFromLocalStorageSuccess = createAction(
  PlayerActionTypes.LoadPlaylistFromLocalStorageSuccess,
  props<{ playlist: PlaylistInterface }>(),
);
export const LoadPlaylistSuccess = createAction(PlayerActionTypes.LoadPlaylistSuccess, props<{ playlist: PlaylistInterface }>());

export const LoadPlaylistFailure = createAction(PlayerActionTypes.LoadPlaylistFailure);

export const SetInitialTracks = createAction(PlayerActionTypes.SetInitialTracks, props<{ tracks: EventInterface[] }>());

export const SaveTrackListIntoLocalStorage = createAction(
  PlayerActionTypes.SaveTrackListIntoLocalStorage,
  props<{ tracks: EventInterface[] }>(),
);
export const LoadMoreTracks = createAction(PlayerActionTypes.LoadMoreTracks);

export const LoadMoreTracksSuccess = createAction(PlayerActionTypes.LoadMoreTracksSuccess, props<{ tracks: EventInterface[] }>());

export const LoadMoreTracksFailure = createAction(PlayerActionTypes.LoadMoreTracksFailure);
export const PlayerIsReady = createAction(PlayerActionTypes.PlayerIsReady);
export const SetPrayerTimeOn = createAction(PlayerActionTypes.SetPrayerTimeOn);
export const SetPrayerTimeOff = createAction(PlayerActionTypes.SetPrayerTimeOff);
export const SetAdOn = createAction(PlayerActionTypes.SetAdOn);
export const SetAdOff = createAction(PlayerActionTypes.SetAdOff);

// Main Audio actions
export const LoadNextTrack = createAction(PlayerActionTypes.LoadNextTrack);
export const LoadNextTrackSuccess = createAction(PlayerActionTypes.LoadNextTrackSuccess, props<{ nextTrack: EventInterface }>());
export const LoadNextTrackFailure = createAction(PlayerActionTypes.LoadNextTrackFailure, props<{ error: any; track: EventInterface }>());

export const LoadNextTrackAndPlay = createAction(PlayerActionTypes.LoadNextTrackAndPlay);
export const Play = createAction(PlayerActionTypes.Play);
export const PlayNext = createAction(PlayerActionTypes.PlayNext);
export const ToggleMute = createAction(PlayerActionTypes.ToggleMute);
export const Mute = createAction(PlayerActionTypes.Mute);
export const Unmute = createAction(PlayerActionTypes.Unmute);

export const ChangeVolume = createAction(PlayerActionTypes.ChangeVolume, props<{ volume: number }>());

export const ChangeVolumeSuccess = createAction(PlayerActionTypes.ChangeVolumeSuccess);
export const IsOnline = createAction(PlayerActionTypes.IsOnline);
export const IsOffline = createAction(PlayerActionTypes.IsOffline);
export const CleanObservers = createAction(PlayerActionTypes.CleanObservers);
export const ResetAll = createAction(PlayerActionTypes.ResetAll);
export const ResetAllSuccess = createAction(PlayerActionTypes.ResetAllSuccess);

// Location Information
export const RefreshLocationInformation = createAction(PlayerActionTypes.RefreshLocationInformation);

export const RefreshLocationInformationSuccess = createAction(
  PlayerActionTypes.RefreshLocationInformationSuccess,
  props<{ location: LocationModel }>(),
);

export const RefreshLocationInformationFailure = createAction(PlayerActionTypes.RefreshLocationInformationFailure, props<{ error: any }>());

export const BypassTrackAndLoadNext = createAction(PlayerActionTypes.BypassTrackAndLoadNext, props<{ track: EventInterface }>());

export const AutoplayPermissionDenied = createAction(PlayerActionTypes.AutoplayPermissionDenied);
export const AutoplayPermissionAllowed = createAction(PlayerActionTypes.AutoplayPermissionAllowed);

export const statusListener1 = createAction(PlayerActionTypes.statusListener1);
export const statusListener2 = createAction(PlayerActionTypes.statusListener2);
export const statusListener3 = createAction(PlayerActionTypes.statusListener3);

export const SendWrongRuntime = createAction(PlayerActionTypes.SendWrongRuntime, props<{ track: string; runtime: number }>());
export const SendWrongRuntimeSuccess = createAction(PlayerActionTypes.SendWrongRuntimeSuccess);
export const SendWrongRuntimeFailure = createAction(PlayerActionTypes.SendWrongRuntimeFailure);
